<template>
  <div>
    <label class="titlePage">Descrição das Opções de Inscrição para Vagas Reservadas</label>

    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="vagasReservadas"
      :porPage="itemsPorPage"
      @row-selected="selecionaLinha"
    />

    <div class="text-right mb-3">
      <fccButton @click="importar">Importar</fccButton>
    </div>
  </div>
</template>
<script>
export default {
  props: ['vagas-reservadas'],
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'ordem', label: 'Ordem', sortable: true },
        { key: 'idcampo', label: 'ID Campo', sortable: true },
        { key: 'valor', label: 'Valor', sortable: true },
        { key: 'descricao', label: 'Descricao', sortable: true }
      ],
      itemsPorPage: '10',
      dadosSelecionados: []
    }
  },
  methods: {
    selecionaLinha(dados) {
      this.dadosSelecionados = dados
    },
    importar() {
      this.$emit('importar', this.dadosSelecionados)
    }
  }
}
</script>